import { useI18n } from '../../i18n';
import { RadioCards } from '../../components/Field';
import { ANALYSIS_KINDS, type AnalysisKind } from '../../lib/types';
import { analysisDescriptionKey, analysisMessageKey } from './parameters';

export function AnalysisPicker({
  value,
  onChange,
}: {
  value: AnalysisKind;
  onChange: (next: AnalysisKind) => void;
}) {
  const { t } = useI18n();

  return (
    <RadioCards
      wide
      legend={t('analysis.label')}
      name="analysis"
      value={value}
      onChange={onChange}
      options={ANALYSIS_KINDS.map((kind) => ({
        value: kind,
        title: t(analysisMessageKey(kind)),
        description: t(analysisDescriptionKey(kind)),
      }))}
    />
  );
}
